import chunk from 'lodash/chunk';
import React from 'react';
import { Column, Row } from '../../components/Grid';
import NavigationGroup from '../../components/layout/NavigationGroup';
import { Navigation, NavigationList } from '../../components/Navigation';
import { Title } from '../../components/Title';
import { selectMenu } from '../../provider/Typo3Provider/selectors';
import { MenuEntry } from '../../provider/Typo3Provider/types';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';

interface LinksContainerProps {}

const FooterLinks = Row.extend`
  padding-top: 80px;
`;

const renderMenuEntry = (
  menuEntry: MenuEntry,
  index: number,
  menuEntries: MenuEntry[]
) => {
  let navigation = null;
  if (menuEntry.children) {
    const { children } = menuEntry;
    const columns = chunk(children, Math.ceil(children.length / 2));
    navigation = (
      <Navigation type='footer'>
        <Row>
          {columns.map((entries, index) => (
            <Column large={6} key={index}>
              <NavigationList>
                <NavigationGroup entries={entries} />
              </NavigationList>
            </Column>
          ))}
        </Row>
      </Navigation>
    );
  }

  return (
    <Column key={menuEntry.uid} large={12 / menuEntries.length}>
      <Title.Group>{menuEntry.title}</Title.Group>
      {navigation}
    </Column>
  );
};

const LinksContainer = ({ typo3 }: LinksContainerProps & WithTypo3Props) => {
  const footer = selectMenu(typo3, 'footer');
  const locations = selectMenu(typo3, 'locations');
  return (
    <FooterLinks>{[...footer, ...locations].map(renderMenuEntry)}</FooterLinks>
  );
};

export default withTypo3(LinksContainer);
